import * as yup from 'yup';
import { subUserENTRightsList } from '../../../../../../../utils/helpers/user/getSubUserRightLabel';

export const getUpdateSubUserForm = yup.object().shape({
  firstName: yup.string().required('Ce champs est requis'),
  lastName: yup.string().required('Ce champs est requis'),
  email: yup.string().email("Adresse email est invalide").required('Une adresse email est requise'),
  // password: yup.string().min(6, 'Votre mot de passe doit contenir au moins 6 caractères'),
  // rights: yup.string().required('Ce champs est requis'),
  ...(subUserENTRightsList.reduce((keys, key) => Object.assign(keys, { [key]: yup.boolean() }), {}))
})